import Vue from 'vue';

export default {
    generateContent (product) {

        var base64 = this.textToBase64Barcode(product.barcode);

        let content = `
            <style type="text/css" media="screen, print">
                @import url('https://fonts.googleapis.com/css2?family=Karla:ital,wght@0,400;0,700;1,400;1,700&display=swap');
            
                @import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700&display=swap');
                
                .content-barcode {
                    width: 100%;
                    margin-left: 0px;
                    margin-right: 0px;
                    top: 0 !important;
                }

            </style>

            <div class="content-barcode">
                <table style="width: 100%; border-collapse: collapse;">
                    <tbody>
                        <tr>
                            <td style="width: 50%;">
                                <img style="display:block; margin:auto; vertical-align: middle;" src="${base64}" width="135px" height="70px"/>
                            </td>
                            <td style="width: 50%;">
                                <img style="display:block; margin:auto; vertical-align: middle;" src="${base64}" width="135px" height="70px"/>
                            </td>
                        </tr>
                    </tbody>
                </table>                
            </div>
        `;

        return content;

    },

    textToBase64Barcode(text){
        var JsBarcode = require('jsbarcode');

        var canvas = document.createElement("canvas");
        JsBarcode(canvas, text, {format: "CODE128"}); //CODE39
        return canvas.toDataURL("image/png");
    }
}